export const getUnit = (fieldLabel: string): string => {
  const unit = fieldLabel.split(" ").pop();
  switch (unit) {
    case "percentage":
      return "%";
    default:
      return ` ${unit}`;
  }
};

export function removeUnit(fieldLabel: string): string {
  const label = fieldLabel.split(" ");
  label.pop(); // last word in field name is always the unit

  return label.join(" ");
}
